import DeferredContent from '/src/class/DeferredContent.js';

window.DeferredContent = DeferredContent;
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => DeferredContent.init(), { once: true });
} else {
    DeferredContent.init();
}
